export interface PatientFieldProps {
    label: string;
    value: string;
    type?: 'text' | 'date' | 'number' | 'email';
    placeholder?: string;
    onChange: (value: string) => void;
}

export function PatientField({ label, value, type = 'text', placeholder, onChange }: PatientFieldProps) {
    return (
        <div className="flex items-center gap-0.5 border-b border-gray-200 pb-2">
            <span className="w-32 shrink-0 text-[9px] font-semibold uppercase tracking-wide text-gray-500">
                {label}
            </span>
            <input
                type={type}
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
                className="flex-1 rounded border border-gray-300 px-1.5 py-0.5 text-[11px] text-gray-800 outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-200"
            />
        </div>
    );
}
